import React, { useEffect } from 'react';
import { Gift, Users, Droplet, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { specialDeals, businessInfo } from '../mockData';

export const ExclusiveDealsPage = () => {
  useEffect(() => {
    document.title = "Exclusive Deals | Dezire Metal Roofing Sydney";
  }, []);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/oei26rau_bb503543-bdc3-4a9b-9b8c-c511d3066285.jpeg')] bg-cover bg-center opacity-20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <Badge className="mb-4 bg-primary/20 text-primary border-primary/30 text-lg px-4 py-1">
              Limited Time Offers
            </Badge>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Exclusive <span className="text-primary">Deals</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Take advantage of our special offers and save on your metal roofing project.
            </p>
          </div>
        </div>
      </section>

      {/* Deals Grid */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {specialDeals.map((deal, index) => (
              <Card key={index} className="relative overflow-hidden border-2 border-primary/20 hover:border-primary/50 transition-all duration-300 hover:shadow-xl">
                <div className="absolute top-0 right-0 bg-primary text-white px-4 py-1 rounded-bl-lg font-semibold">
                  {deal.savings}
                </div>
                <CardHeader className="pt-8">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                    {deal.type === 'referral' ? (
                      <Users className="w-8 h-8 text-primary" />
                    ) : (
                      <Droplet className="w-8 h-8 text-primary" />
                    )}
                  </div>
                  <CardTitle className="text-2xl">{deal.title}</CardTitle>
                  <CardDescription className="text-base">{deal.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="bg-gray-50 rounded-lg p-4 mb-4">
                    <p className="text-sm text-gray-600">{deal.terms}</p>
                  </div>
                  <Link to="/book-inspection">
                    <Button className="w-full bg-primary hover:bg-accent">
                      Claim This Offer
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Don't Miss Out!</h2>
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
            These exclusive deals won't last forever. Contact us today to take advantage of these savings.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/book-inspection">
              <Button size="lg" className="bg-primary hover:bg-accent text-white">
                Book Free Inspection
              </Button>
            </Link>
            <a href="/call">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-gray-900">
                <Phone className="w-5 h-5 mr-2" />
                Call {businessInfo.phone}
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
